<ng-container *ngFor="let correspondence of correspondenceList">
    <cpc-document [name]="correspondence[0].subclassidLabel" [date]="correspondence[0].createTs | dateFormat"
        (clickDownload)="clickDownload(correspondence[0].itemId)" copyDownload="{{'policy.download' | translate}}">
        <ng-container *ngFor="let file of correspondence | slice:1">
            <cpc-document [name]="file.subclassidLabel" [date]="file.createTs | dateFormat"
                (clickDownload)="clickDownload(file.itemId)"
                copyDownload="{{'policy.download' | translate}}"></cpc-document>
        </ng-container>
    </cpc-document>
</ng-container>